export const stepTwoData = [
  {
    heading: "Key Features of AXIS Bank Personal Loan EMI Calculator",

    tableContent: {
      heading: [
        {
          head: "Loan Type",
        },
        {
          head: "Interest Rate",
        },
        {
          head: "Loan Tenure",
        },
        {
          head: "Processing Fees",
        },
      ],
      row: [
        {
          type: "Personal Loan",
          interest: "10.25% to 24% p.a.	",
          tenure: "12 months to 60 months",
          fee: "1% to 2% of loan amount (Max ₹25,000)",
        },
      ],
    },
  },
];

export const stepThreeData = [
  {
    heading: "Factors Affecting Your EMI and Total Repayment",

    factorsList: [
      {
        heading: "Loan Amount: ",
        info: "The higher the loan amount, the higher the EMI, unless the tenure is extended. It's essential to calculate the exact amount you need to borrow to avoid financial strain.",
      },
      {
        heading: "Interest Rate: ",
        info: "AXIS Bank offers competitive interest rates based on factors like your credit score, income, and loan amount. Lower interest rates reduce both the EMI and the overall repayment.",
      },
      {
        heading: "Loan Tenure: ",
        info: "The tenure plays a major role in the EMI amount. A longer tenure lowers the EMI but results in more interest paid, whereas a shorter tenure reduces the total interest but increases the EMI.",
      },
      {
        heading: "Processing Fees: ",
        info: "AXIS Bank charges processing fees of 1% to 2% of the loan amount (subject to a maximum of ₹25,000), which should be considered when calculating the overall cost of the loan.",
      },
    ],
  },
];

export const stepFourData = [
  {
    heading: "How Loan Tenure Impacts Your EMI and Total Repayment",
    paraOne:
      "The loan tenure can significantly impact both your monthly EMI and total repayment. Below is a table illustrating how different tenures affect the EMI and total repayment:",
    tableContent: {
      heading: [
        {
          head: "Loan Tenure",
        },
        {
          head: "Monthly EMI",
        },
        {
          head: "Total Interest",
        },
        {
          head: "Total Repayment",
        },
      ],
      row: [
        {
          tenure: "1 year",
          emi: "Higher EMI",
          interest: "Low Interest",
          repayment: "Lower Total Repayment",
        },
        {
          tenure: "2 years",
          emi: "Moderate EMI",
          interest: "Moderate Interest",
          repayment: "Moderate Total Repayment",
        },
        {
          tenure: "3 years",
          emi: "Lower EMI	",
          interest: "Higher Interest",
          repayment: "Higher Total Repayment",
        },
        {
          tenure: "5 years",
          emi: "Very Low EMI	",
          interest: "Much Higher Interest	",
          repayment: "Much Higher Total Repayment",
        },
      ],
    },
    note: "A longer tenure leads to smaller EMIs but increases the overall interest paid. On the other hand, a shorter tenure reduces the total interest but increases the monthly EMI.",
  },
];

export const stepFiveData = [
  {
    heading: "Why Choose APR Over Just Interest Rate?",
    tip: "A loan with a slightly higher interest rate but lower processing fees may be more affordable in the long run if the APR is lower.",
  },
];

export const stepSixData = [
  {
    heading: "AXIS Bank Personal Loan EMI Breakdown",
    paraOne: "Personal Loan EMIs are typically split into two components:",
    infoList: [
      {
        head: "Principal Repayment: ",
        info: "The amount of the loan principal paid off with each EMI.",
      },
      {
        head: "Interest Payment: ",
        info: "The cost of borrowing, which is applied on the remaining loan balance.",
      },
    ],
    paraTwo:
      "In the initial months of your loan tenure, the larger portion of the EMI goes toward paying off the interest, while in later months, the focus shifts to repaying the principal.",
  },
];

export const stepSevenData = [
  {
    heading: "Understanding Your AXIS Bank Personal Loan EMI",
    paraOne:
      "Understanding how your EMI is calculated will help you manage your finances better. Knowing your EMI in advance ensures you’re prepared for the repayment and can budget accordingly.",
  },
];

export const stepEightData = [
  {
    heading: "MinEmi Tips for AXIS Bank Personal Loan Borrowing",
    infoList: [
      {
        head: "Evaluate Your Credit Score: ",
        info: "A higher credit score (750+) helps secure a loan at a lower interest rate, which will lower your EMI. If your credit score is lower, consider improving it before applying.",
      },
      {
        head: "Understand Your Loan Amount: ",
        info: "Borrow the amount you need. Avoid borrowing more than necessary to ensure lower EMIs and total repayment.",
      },
      {
        head: "Opt for the Right Tenure: ",
        info: "While a longer tenure reduces EMI, it also increases the total interest paid. Choose a tenure that balances your monthly affordability and total repayment cost.",
      },
      {
        head: "Prepayment Options: ",
        info: "AXIS Bank allows for part prepayments, which can reduce the outstanding principal and save on interest. Consider making partial repayments if your financial situation improves.",
      },
    ],
  },
];
